module.exports = __webpack_public_path__ + "static/media/empty-en.5860ee85.png";